export const SmsJobsTypes = {
    SHOW_SMS_JOBS: "SHOW_SMS_JOBS",
    ADD_SMS_JOBS: "ADD_SMS_JOBS",
    UPDATE_SMS_JOBS: "UPDATE_SMS_JOBS",
    DELETE_SMS_JOBS:"DELETE_SMS_JOBS"
  }